module.exports = __webpack_public_path__ + "static/img/value_of_certification.b5c43f3d.jpg";